import { defineStore } from "pinia";
import { ref } from "vue";

export const useWinnersInfoStore = defineStore('winnersInfo', () => {
    const needOfferPrice = ref(false);
    const showPriceInsteadOfCost = ref(false);
    const customFieldInsteadOfCost = ref(null);

    function setNeedOfferPrice(value) {
        needOfferPrice.value = value;
    }

    function setShowPriceInsteadOfCost(value) {
        showPriceInsteadOfCost.value = value;
    }

    function setCustomFieldInsteadOfCost(value) {
        customFieldInsteadOfCost.value = value;
    }

    return {
        needOfferPrice,
        setNeedOfferPrice,
        showPriceInsteadOfCost,
        setShowPriceInsteadOfCost,
        customFieldInsteadOfCost,
        setCustomFieldInsteadOfCost
    }
});
